import React from "react";

const About = () => {
  return (
    <section className="about-me" id="about">
      <div className="container pt-8">
        <div className="about-me-text mt-5 text-center position-relative">
          <h1 className="position-absolute know-text">Know Me More</h1>
          <h1 className="about-me-txt text-muted">About Me</h1>
        </div>

        <div className="row">
          {/* ======================1=============== */}
          <div className="col-md-12 col-lg-7 col-sm-12">
            <div className="mt-5">
              <h1 className="text-light">
                I am <span className="myName">Afeef Ali,</span> a Web Developer
              </h1>
              <p className="text-muted fs-lg-5 mt-4" style={{ fontWeight: "600" }}>
                With one years of expertise, I specialize in HTML, CSS, and
                JavaScript, staying up-to-date with the latest web development
                trends. I am committed to delivering high-quality websites that
                align with your brand, drive results, and exceed your
                expectations. Let's collaborate and bring your website ideas to
                reality!
              </p>
              <p className="mt-3 text-muted fs-lg-5" style={{ fontWeight: "600" }}>
                I'm a reliable website developer who delivers high-quality
                projects on time, ensuring exceptional results that exceed
                expectations.
              </p>
            </div>
          </div>
          {/* ==================2============== */}
          <div className="col-md-12 col-lg-5 col-sm-12 flex">
            {/* ==================table=================== */}
            <table className="table">
              <tbody>
                <tr>
                  <td>
                    <strong>Name:</strong>
                  </td>
                  <td>Mohd Afeef</td>
                </tr>
                <tr>
                  <td><strong>Email:</strong></td>
                  <td id="td"><a href="mailto:mohdafeefali080@gmail.com"> mohdafeefali080@gmail.com </a></td>
                </tr>
                <tr>
                  <td><strong>Location:</strong></td>
                  <td>Hyderabad,India</td>
                </tr>
              </tbody>
            </table>
            {/* ==================table=================== */}
          </div>
        </div>

        <div className="row mt-10 text-center">
          {/* ===============1=============== */}
          <div className="col-md-6 col-6">
            <div className="inner-box">
              <h1 className="text-muted text-3rem">1+</h1>
              <h2 className="text-light fw-light">Experience</h2>
            </div>
          </div>
          {/* ===============2=============== */}
          <div className="col-md-6 col-6">
            <div className="inner-box in-box">
              <h1 className="text-muted text-3rem">15+</h1>
              <h2 className="text-light fw-light">Projects</h2>
            </div>
          </div>
        
        </div>
      </div>
    </section>
  );
};

export default About;
